import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Splash from '../../../../../ui/src/layouts/components/Splash/Splash';
import { BookModel, Chapter } from '../../../../../ui/src/models/book/bookModel';
import SachMemLesson from './SachMemLesson';

const SachMemView: React.FC<{ book: BookModel }> = ({ book }) => {
  const navigate = useNavigate();
  const [currentChapter, setCurrentChapter] = useState<Chapter>();
  const [chapterView, setChapterView] = useState<Chapter>();
  const [isLoading, setIsLoading] = useState(false);

  const { chapterId } = useParams<any>();

  useEffect(() => {
    if (!chapterId && book.chapters.length > 0) {
      navigate(`/book/${book.id}/${book.chapters[0].id}`);
    }
    setCurrentChapter(book.chapters.find((c) => c.id === chapterId));
    // eslint-disable-next-line
  }, [book, chapterId]);

  // useEffect(() => {
  //   if (!currentChapter) {
  //     return;
  //   }
  //   setIsLoading(true);
  //   getSkillChapter(currentChapter.id)
  //     .then((res) => {
  //       setChapterView(res.data);
  //       setIsLoading(false);
  //     })
  //     .catch(() => setIsLoading(false));
  // }, [currentChapter]);

  const handleClickUnit = (chapter) => {
    // setCurrentChapter(chapter);
    navigate(`/book/${book.id}/${chapter.id}`);
  };

  const isNumeric = (num) => {
    return !isNaN(num);
  };

  const firstLineChapters = book.chapters.filter((c) => isNumeric(c.name));
  const secondLineChapters = book.chapters.filter((c) => !isNumeric(c.name));

  return (
    <div className="sachmem">
      <img
        className="sachmem-top-img"
        src="\images\book\sachmem\sachmem_top.svg"
        alt=""
      />
      <div className="container position-relative">
        <div className="text-center">
          <div className="sachmem-top-sign">
            <img src="\images\book\sachmem\sachmem_sign.svg" alt="" />
            <b className="book-title">
              {'Tiếng Anh' /*Translate('english', 'Tiếng Anh')*/}{' '}
              {/*grades.find((g) => g.id === book.gradeId).level*/}
            </b>
          </div>
        </div>
        <div className="units">
          <div className="left-part">
            <div className="element label">Unit</div>
          </div>
          <div className="right-part">
            <div className="first-line">
              {firstLineChapters.map((c, i) => (
                <div
                  key={i}
                  className={`element no-select ${
                    currentChapter && c.id === currentChapter.id ? 'active' : ''
                  }`}
                  onClick={() => handleClickUnit(c)}>
                  {c.name}
                </div>
              ))}
            </div>
            {firstLineChapters.length > 0 && secondLineChapters.length > 0 && (
              <div className="line" />
            )}
            <div className="second-line">
              {secondLineChapters.map((c, i) => (
                <div
                  key={i}
                  className={`element no-select ${
                    currentChapter && c.id === currentChapter.id ? 'active' : ''
                  }`}
                  onClick={() => handleClickUnit(c)}>
                  {c.name}
                </div>
              ))}
            </div>
          </div>
        </div>
        {isLoading ? (
          <Splash />
        ) : (
          <>
            {currentChapter && (
              <div className="unit-name">
                <div className="title">
                  {isNumeric(currentChapter.name)
                    ? `Unit ${currentChapter.name}: ${
                        currentChapter.title || ''
                      }`
                    : `${currentChapter.name || ''} ${
                        currentChapter.title || ''
                      }`}
                </div>
              </div>
            )}
            {chapterView && (
              <div className="lessons pb-5">
                <Row>
                  {chapterView.lessons.map((l, i) => (
                    <Col xl={4} lg={6}>
                      <SachMemLesson lesson={l} index={i} />
                    </Col>
                  ))}
                </Row>
              </div>
            )}
          </>
        )}
      </div>
      <img
        className="sachmem-bottom-img"
        src="\images\book\sachmem\sachmem_bottom.svg"
        alt=""
      />
    </div>
  );
};

export default SachMemView;
